<template>
  <div
    v-loading="pageLoading"
    class="history-body history-person"
  >
    <navMenu
      v-if="navList.length > 0"
      :nav="navList"
      :name="'地区库'"
      :opens="['0']"
    />
    <div
      :class="{'header-hide':!(!$route.params.column || ($route.params.column && $route.params.propType))}"
      class="history-list-body"
    >
      <breadCrumb :route-list="routeList" />
      <div class="list-content">
        <p
          v-if="!$route.params.column || ($route.params.column && $route.params.propType)"
          class="list-title"
        >
          <span class="list-name"><span class="libary">{{ routeList[routeList.length - 1].name }} 列表</span></span>
          <!--<span class="list-name"><span>地区库{{routeList[routeList.length - 1].name}}标题列表</span></span>-->
          <el-input
            v-if="searchShow"
            v-model="keyword"
            placeholder="请输入关键词"
            class="float-right"
            @keyup.enter.native="initPage"
          >
            <el-button
              slot="append"
              icon="search"
              @click="initPage"
            />
          </el-input>
        </p>
        <div
          v-loading="moduleLoading"
          class="el-list-container scroll-container"
        >
          <personList
            v-if="nameList.length > 0"
            :list="nameList"
          />
          <listMore
            v-if="moreList.length > 0"
            :list="moreList"
            :column-index="4"
            :number="3"
          />
          <gambitList
            v-if="gambitList.Name && !$route.params.propType"
            :list="gambitList"
            :class="{'no-title': gambitList.Name}"
            @showArticle="getArticle"
          />
          <documentList
            v-if="$route.params.propType"
            :list="documentData"
            @showArticle="getArticle"
            @pageChange="getDocument"
          />
          <div
            v-if="nameList.length === 0 && !moduleLoading && moreList.length === 0 && !gambitList.Name && !documentData.Total"
            class="no-data"
            align="center"
          >暂无数据</div>
        </div>
      </div>
    </div>
    <articleDialog
      :article="articleData"
      :dialog-visible="dialogShow"
      class="article-dialog"
    />
  </div>
</template>

<script>
  import navMenu from '@/modules/history/nav-menu.vue'
  import breadCrumb from '@/modules/history/bread-crumb.vue'
  import listMore from '@/modules/history/list-more.vue'
  import gambitList from '@/modules/history/gambit-list.vue'
  import documentList from '@/modules/history/document-list.vue'
  import articleDialog from '@/modules/history/artile-dialog.vue'

  import {historyEventService} from '@/service/httpService'
  import personList from '@/modules/history/person-list.vue'
  import {globalService} from '@/service/globalService'
  import {historyService} from '@/service/historyService'
  import CreateNavService from '@/service/createNavService'
  import GetColumnInformation from '@/service/getColumnInfo'

  export default {
    name: 'HistoryRegion',
    components: { navMenu, breadCrumb, listMore, gambitList, personList, documentList, articleDialog},
    data () {
      return {
        keyword: '',
        pageLoading: false,
        moduleLoading: false,
        searchShow: false,
        codes: [],
        routeList: [{url: '', name: '地区'}],
        navList: [],
        moreList: [],
        gambitList: {},
        nameList: [],
        filteredNameList: [],
        leftMenuData: [],
        documentData: {},
        dialogShow: {show: false},
        articleData: {}
      }
    },
    watch: {
      '$route': function () {
        this.keyword = ''
        this.routeChange()
        this.initPage()
        historyService.handleMenuData(this.navList[0], this.$route.params, window.dictionaryConfig.personLevel.nameLevel)
      }
      // nameList () {
      //   this.filteredNameList = this.nameList
      // }
    },
    mounted () {
       this.codes = historyService.getCode()
      this.routeChange()
      this.getLeftMenu()
      this.initPage()
    },
    methods: {
      searchPage () {
        let params = this.$route.params
        console.log(' params: ', params)
        if (params.time === undefined) {
          console.log('time0')
          this.filteredNameList = this.filterList(this.nameList, 0)
        } else {
          this.filterList(this.nameList, 1)
        }
      },
      filterList (list, type) {
        let filteredList = []
        if (!type) {
          let temp = {}
          list.forEach(items => {
            temp = JSON.parse(JSON.stringify(items))
            if (temp.Columns) {
              temp.Columns = items.Columns.filter(item => item.Name.indexOf(this.keyword) >= 0)
              temp.Total = temp.Columns.length
            }
            if (temp.gambit) {
              temp.gambit = items.gambit.filter(item => item.Name.indexOf(this.keyword) >= 0)
              temp.Total = temp.gambit.length
            }
            if (temp.Total !== 0) {
              filteredList.push(temp)
            }
          })
          return filteredList
        } else {
          let params = this.$route.params
          let url = window.dataUrl.History.regionColumns
          let codes = window.dictionaryConfig.personLevel.nameLevel[params.time]
          url = codes ? historyService.handleUrl(url, codes) : url
          let param = {
            searchWord: this.keyword
          }
          this.moduleLoading = true

          historyEventService.loadCodes(url, param).then(res => {
            if (res.status === 200) {
              this.nameList = res.data
              this.moduleLoading = false
            }
          }, error => globalService.showErrNofify(error))
        }
      },
      getDocument (currentPage) {
        let params = this.$route.params
        let documentUrl = window.dataUrl.History.documentsRegion.replace('{id}', params.column)
        this.documentData = {}
        historyEventService.loadColums(documentUrl, {propType: params.propType, page: currentPage, pageSize: 20}).then(res => {
          this.documentData = res.data
        })
      },
      getArticle (id) {
        globalService.showArticle(id, this)
      },
      routeChange () {
        let params = this.$route.params
        this.routeList = [{url: '', name: '地区'}]
        this.routeList = historyService.routeChange(this.routeList, params, window.dictionaryConfig.regionLevel)
      },
      getColumns (url) {
        let me = this
        me.moreList = []
        me.nameList = []
        me.gambitList = {}
        me.moduleLoading = true
        let param = {
          searchWord: this.keyword
        }
        historyEventService.loadCodes(url, param).then(res => {
          if (res.status === 200) {
            me.nameList = res.data
            me.moduleLoading = false
          }
        }, error => globalService.showErrNofify(error))
      },
      initPage () {
        let params = this.$route.params
        let url = window.dataUrl.History.regionColumns
        if (!params.column) {
          this.searchShow = true
          let codes = window.dictionaryConfig.personLevel.nameLevel[params.time]
          url = codes ? historyService.handleUrl(url, codes) : url
          this.getColumns(url)
        } else {
          this.moduleLoading = true
          this.searchShow = true
          var loadColumn = new GetColumnInformation(this, window.dataUrl.History.columnRegionCheck, window.dataUrl.History.documentsRegion)
          loadColumn.getColumn()
        }
      },
      getLeftMenu: function () {
        let me = this
        me.pageLoading = true
        let createNavService = new CreateNavService(me, window.dataUrl.History.countRegionByLetter, '', window.dictionaryConfig.personLevel.nameLevel)
        createNavService.createOneMenu()
      }
    }
  }

</script>




// WEBPACK FOOTER //
// src/pages/history/history-region.vue